import React, { Component, Children, cloneElement } from "react"
import { createPortal } from "react-dom"
import PropTypes from "prop-types"
import Navigation from "../../../store/containers/navigation"
import Header from "../../../store/containers/titles"
import EmployeesContainer from "../../../store/containers/employees.js"
import ProductsContainer from "../../../store/containers/products.js"
import BenefitsContainer from "../../../store/containers/benefits.js"
import "../../../scss/main.css"
// import ConnectGuestList from '../../../store/containers/ConnectGuestList'
// import GuestList from '../../components/GuestList'
import { Route, Switch } from "react-router-dom"
import uuid from "uuid"
import axios from "axios"
import moment from "moment"
import Papa from "papaparse"
import Statistics from "../../pages/statistics/Statistics"
import Groups from "../../pages/Groups"
import Reservations from "../../components/reservations/Reservations.js"
import Guests from "../../pages/Guests"
import GuestlistsReal from "../../components/guestlists/Guestlists.js"
import Communications from "../../components/communication/Communications.js"

import Settings from "../../components/settings/settings"
import FrontPageContainer from "../../pages/frontPage/frontPage"

moment.locale("nb")

const token = window.localStorage.getItem("token")

const norsk = {
    January: "Januar",
    February: "Februar",
    March: "Mars",
    April: "April",
    May: "Mai",
    June: "Juni",
    July: "Juli",
    August: "August",
    September: "September",
    October: "Oktober",
    November: "November",
    December: "Desember",
}

export class MakeCalendar {
    constructor(val) {
        if (!val) val = 0
        if (val > 0 || val < 0) {
            this.val = moment().add(val, "month")
        } else {
            this.val = moment().get("month")
        }
        console.log(
            moment()
                .add(val, "month")
                .format("MMMM")
                .toString(),
        )
        return {
            name: moment()
                .add(val, "month")
                .format("MMMM")
                .toString(),
            abbrivation: moment()
                .add(val, "month")
                .format("MMM")
                .toString(),
            year: moment()
                .add(val, "month")
                .format("YYYY")
                .toString(),
            month: moment()
                .add(val, "month")
                .format("MM")
                .toString(),
            start: moment()
                .add(val, "month")
                .date(1)
                .format("dddd")
                .toString(),
            day: moment()
                .add(val, "month")
                .format("DD")
                .toString(),
            weekday: moment()
                .add(val, "month")
                .date(0)
                .isoWeekday()
                .toString(),
            daysInMonth: moment()
                .add(val, "month")
                .daysInMonth(),
        }
    }
}

const theme = {
    lightBackground: "#ffffff",
    darkBackground: "#202020",
    darkColor: "#202020",
    lightColor: "#ffffff",
}

const styles = ui => ({
    form: {
        input: {
            borderRadius: "4px",
            boxShadow: `0px 10px 20px -5px rgba(0,0,0,.3)`,
            padding: "15px 20px",
            backgroundColor: ui === "light" ? theme.lightBackground : theme.darkBackground,
            color: ui === "light" ? theme.darkColor : theme.lightColor,
        },
        button: {
            outline: "none",
            border: "none",
        },
    },
    modal: {
        backgroundColor: ui === "light" ? theme.lightBackground : theme.darkBackground,
        color: ui === "light" ? theme.darkColor : theme.lightColor,
    },
    list: {
        main: {
            color: ui === "light" ? theme.darkColor : theme.lightColor,
        },
        listItem: {
            padding: `10px 15px 10px 0px`,
            boxSizing: "border-box",
            fontSize: "14px",
        },
    },
})

class Form extends Component {
    constructor(props) {
        super(props)

        this.state = {
            id: this.props.id,
        }

        if (this.props.children.length > 1) {
            this.props.children.map(child =>
                Object.assign(this.state, {
                    [child.props.name]: "",
                    [child.props.name + "-error"]: false,
                }),
            )
        } else {
            Object.assign(this.state, {
                [this.props.children.props.name]: "",
                [this.props.children.props.name + "-error"]: false,
            })
        }

        this.handleFieldUpdate = this.handleFieldUpdate.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.fetchData = this.fetchData.bind(this)

        this.elements = []

        Children.forEach(this.props.children, child => {
            this.elements.push(cloneElement(child, { onChange: this.handleFieldUpdate.bind(this) }))
        })
    }

    validate(key, value) {
        switch (key) {
            case key.includes("name"):
                return /^[a-zA-ZÆØÅ]+$/.test(value)
            case key.includes("mail"):
                return /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(value)
            case key.includes("phone") || key.includes("tlf"):
                return /\d+/.test(value)
            default:
                return true
        }
    }

    async handleFieldUpdate(e) {
        let { name, value } = e.target
        await this.setState({ [name]: value })
        if (!this.state[name]) {
            let res = await this.fetchData()
            this.props.context.setState({
                data: res.data || [],
            })
        }
    }

    async fetchData(part = "") {
        let { day, url, month } = this.props.context.state
        let { month: mnth, year } = new MakeCalendar(month)
        let response = await axios({
            method: "get",
            headers: {
                authorization: token,
            },
            url: url + `?day=${day}&month=${mnth}&year=${year}${part ? "&" + part : ""}`,
        })
        return response
    }

    async handleSubmit(e) {
        e.preventDefault()
        let data = {}
        for (let key in this.state) if (!key.includes("error") && key !== "id") data[key] = this.state[key]

        let res = ""
        if (this.props.query) {
            let str = ""
            for (let key in data) {
                if (data[key]) str += `${key}=${encodeURIComponent(data[key])}`
            }
            res = await this.fetchData(str)
        } else {
            res = await this.fetchData()
        }

        this.props.context.setState({
            data: res.data || [],
        })
    }

    render() {
        let { handleFieldUpdate, handleSubmit, elements } = this

        let { id, submitMessage, style, className } = this.props

        return (
            <form className={className} id={id} onSubmit={handleSubmit}>
                {elements}
                <Submit id={id + "submit"}>{submitMessage}</Submit>
            </form>
        )
    }
}

Form.propTypes = {
    id: PropTypes.string.isRequired,
}

class Actions extends Component {
    constructor(props) {
        super(props)

        this.elements = []

        Children.forEach(this.props.children, child => {
            this.elements.push(cloneElement(child, { onClick: this.toggleClick.bind(this) }))
        })
    }

    toggleClick(e) {
        e.preventDefault()
        let { name } = e.target
        Object.keys(this.props.context.state).forEach(key => {
            if (key === name) {
                this.props.context.setState(prevState => ({ [key]: !prevState[key] }))
            }
        })
    }

    render() {
        let { elements } = this
        return elements
    }
}

const Choose = props => <Button {...props}>Velg</Button>
const ListRow = props => (
    <ul className="row" {...props}>
        {props.children}
    </ul>
)
//const ListCell = props => <li className="cell" {...props}>{props.data}</li>

class ListCell extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <li className="cell" {...this.props}>
                {this.props.data}
            </li>
        )
    }
}

class List extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            page: 0,
            paginated: 0,
            value: 0,
            url: this.props.url,
        }

        this.fetchData = this.fetchData.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handlePage = this.handlePage.bind(this)
        this.handleButtons = this.handleButtons.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
        this.reRenderChildren = this.reRenderChildren.bind(this)

        this.elements = []

        Children.forEach(this.props.children, child => {
            this.elements.push(cloneElement(child, { onClick: this.handleCheck }))
        })
    }

    async fetchData(url) {
        let { method, listName, listKeys } = this.props
        let { page } = this.state

        await this.setState({
            url: url,
        })

        console.log(this.state.url)

        let response = await axios({
            method: method,
            url: `${url}&page=${page || 0}`,
            headers: { authorization: token },
        })

        await this.setState({
            data: response.data[listName],
        })
    }

    handleClick(e) {
        let id = e.target.parentNode.getAttribute("data-id")
        this.props.context.setState({
            activeItem: id,
            info: true,
        })
    }

    async handleCheck(e) {
        e.preventDefault()

        let val = e.currentTarget.getAttribute("data-value")
        let id = e.target.parentNode.getAttribute("data-id")
        let { baseUrl } = this.props

        let { range, max, min } = this.props

        let updateState = check => {
            if (range && max) {
                this.setState(prevState => {
                    let index = prevState.data.findIndex(obj => obj._id === id)
                    if (prevState.data[index][range] < prevState.data[index][max] || prevState.data[index][range] > 0) {
                        check ? prevState.data[index][range]++ : prevState.data[index][range]--
                    }
                    return { data: prevState.data }
                })
            } else {
                console.error("No max or range prop provided.")
                return true
            }
        }

        try {
            updateState(Boolean(parseInt(val)))
            let response = await axios({
                method: "patch",
                headers: {
                    authorization: token,
                },
                url: baseUrl + "/" + id,
                data: {
                    check: Boolean(parseInt(val)),
                },
            })
            await this.fetchData(this.state.url)
        } catch (err) {
            updateState(!Boolean(parseInt(val)))
            console.error(err)
        }
    }

    async handlePage(val) {
        await this.setState(prevState => ({
            page: prevState.page + val,
            paginated: val === 1 ? prevState.paginated + 50 : prevState.paginated - 50,
        }))
        await this.fetchData()
    }

    handleButtons() {
        if (this.state.total > 50 && this.state.paginated >= 50 && this.state.paginated + 50 < this.state.total) {
            return { next: true, previous: true }
        } else if (this.state.total > 50 && this.state.paginated < 50) {
            return { next: true, previous: false }
        } else if (this.state.paginated >= 50) {
            return { next: false, previous: true }
        } else {
            return { next: false, previous: false }
        }
    }

    componentDidMount() {
        this.fetchData(this.state.url)
        this.interval = setInterval(() => {
            this.fetchData(this.state.url)
        }, 20000)
    }

    componentDidWillUnmount() {
        clearInterval(this.interval)
    }

    componentDidUpdate(nextProps, prevProps) {
        if (nextProps.url !== this.state.url) {
            this.fetchData(nextProps.url)
        }
    }

    reRenderChildren() {
        let { data } = this.state
        let { listName, listKeys } = this.props
        let { handleClick, elements } = this

        return (
            data &&
            data.map((item, i) => (
                <ListRow data-id={item.id || item._id || i}>
                    {listKeys.map(key => {
                        if (this.state[key]) {
                            return (
                                <ListCell
                                    data-value={this.state[key][i]}
                                    data={this.state[key][i]}
                                    onClick={handleClick}
                                />
                            )
                        } else {
                            return <ListCell data-value={item[key]} data={item[key]} onClick={handleClick} />
                        }
                    })}
                    {elements}
                </ListRow>
            ))
        )
    }

    render() {
        let { children, listKeys, parent, page, paginated, check, listName } = this.props
        let { list } = styles(this.props.ui)
        let { handleButtons, handleCheck } = this
        return [
            <ul className="list">{this.reRenderChildren()}</ul>,
            handleButtons().previous ? (
                <button
                    className="previous-button"
                    onClick={e => {
                        e.preventDefault()
                        this.handlePage(-1)
                    }}
                >
                    Forrige
                </button>
            ) : (
                ""
            ),
            handleButtons().next ? (
                <button
                    className="next-button"
                    onClick={e => {
                        e.preventDefault()
                        this.handlePage(1)
                    }}
                >
                    Neste
                </button>
            ) : (
                ""
            ),
        ]
    }
}

List.propTypes = {
    listKeys: PropTypes.array.isRequired,
    max: PropTypes.string,
    min: PropTypes.number,
    range: PropTypes.string,
}

/* Calendar Component */

class Calendar extends Component {
    constructor(props) {
        super(props)

        let { month, day, year, name } = new MakeCalendar(0)

        this.state = {
            month: month,
            day: day,
            year: year,
            current: 0,
            name: name,
            url: this.props.url,
        }

        this.handlePage = this.handlePage.bind(this)
        this.selectDate = this.selectDate.bind(this)
        this.makeDaysInMonth = this.makeDaysInMonth.bind(this)
    }

    async handlePage(val) {
        await this.setState(prevState => {
            let { month, year, name, day } = new MakeCalendar(prevState.current + val)
            return {
                current: prevState.current + val,
                month: month,
                year: year,
                name: name,
                day: prevState.current + val === 0 ? day : 1,
            }
        })
        // await this.props.cotext.setState({
        //   url:
        // })
    }

    async selectDate(e) {
        let { current } = this.state
        let { month, year, name } = new MakeCalendar(current)
        let day = e.target.getAttribute("data-day")

        await this.setState({
            day: day,
            year: year,
            month: month,
            name: name,
            url: `${this.props.url}?day=${day < 10 ? "0" + day : day}&month=${month}&year=${year}`,
        })

        await this.props.context.setState({
            url: `${this.props.url}?day=${day < 10 ? "0" + day : day}&month=${month}&year=${year}`,
        })
    }

    makeDaysInMonth() {
        let { current, day } = this.state
        let { selectDate } = this

        let { daysInMonth, weekday } = new MakeCalendar(current)

        if (typeof day === "string") {
            day = parseInt(day)
        }

        let days = Array.from({ length: daysInMonth }, (v, i) => {
            if (i + 1 === day) {
                return (
                    <td onClick={selectDate} data-day={i + 1} key={uuid()} className="calendar-day selected-day">
                        {++i}
                    </td>
                )
            } else {
                return (
                    <td onClick={selectDate} data-day={i + 1} key={uuid()} className="calendar-day">
                        {++i}
                    </td>
                )
            }
        })

        let empty = Array.from({ length: parseInt(weekday) }, v => <td />)

        let rows = []
        let container = []
        ;[...empty, ...days].map((day, i) => {
            if (i % 7 === 0 && !i == 0) {
                rows.push(<tr>{container}</tr>)
                container = []
                container.push(day)
            } else {
                container.push(day)
            }
        })
        return [...rows, <tr>{container}</tr>]
    }

    render() {
        console.log(this.state)
        let { day, month, year, name } = this.state

        let { handlePage, makeDaysInMonth } = this

        return [
            <h1 key={uuid()}>
                {name} {year}
            </h1>,
            <table key={uuid()}>
                <thead>
                    <tr>
                        {"Man0Tirs0Ons0Tors0Fre0Lør0Søn".split`0`.map(day => (
                            <th key={uuid()}>{day}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>{makeDaysInMonth()}</tbody>
            </table>,
            <Previous
                onClick={() => {
                    handlePage(-1)
                }}
            >
                Forrige
            </Previous>,
            <Next
                onClick={() => {
                    handlePage(1)
                }}
            >
                Neste
            </Next>,
        ]
    }
}

export class CalendarJonathan extends Component {
    constructor(props) {
        super(props)

        let { month, day, year, name } = new MakeCalendar(0)

        this.state = {
            month: props.month,
            day: props.day,
            year: props.year,
            current: 0,
            name: props.name,
            url: this.props.url,
        }

        this.handlePage = this.handlePage.bind(this)
        this.selectDate = this.selectDate.bind(this)
        this.makeDaysInMonth = this.makeDaysInMonth.bind(this)
    }

    async handlePage(val) {
        await this.setState(prevState => {
            let { month, year, name, day } = new MakeCalendar(prevState.current + val)
            return {
                current: prevState.current + val,
                month: month,
                year: year,
                name: name,
                day: prevState.current + val === 0 ? day : 1,
            }
        })
    }

    async selectDate(e) {
        let { current } = this.state
        let { month, year, name } = new MakeCalendar(current)
        let day = e.target.getAttribute("data-day")

        await this.setState({
            day: day,
            year: year,
            month: month,
            name: name,
            url: `${this.props.url}?day=${day < 10 ? "0" + day : day}&month=${month}&year=${year}`,
        })
        this.props.date({ day: day < 10 ? "0" + day : day, month, year, name })
    }

    makeDaysInMonth() {
        let { current, day } = this.state
        let { selectDate } = this

        let { daysInMonth, weekday } = new MakeCalendar(current)

        if (typeof day === "string") {
            day = parseInt(day)
        }

        let days = Array.from({ length: daysInMonth }, (v, i) => {
            if (i + 1 === day) {
                return (
                    <td onClick={selectDate} data-day={i + 1} key={uuid()} className="calendar-day selected-day">
                        {++i}
                    </td>
                )
            } else {
                return (
                    <td onClick={selectDate} data-day={i + 1} key={uuid()} className="calendar-day">
                        {++i}
                    </td>
                )
            }
        })

        let empty = Array.from({ length: parseInt(weekday) }, v => <td />)

        let rows = []
        let container = []
        ;[...empty, ...days].map((day, i) => {
            if (i % 7 === 0 && !i == 0) {
                rows.push(<tr>{container}</tr>)
                container = []
                container.push(day)
            } else {
                container.push(day)
            }
        })
        return [...rows, <tr>{container}</tr>]
    }

    render() {
        console.log(this.state)
        let { day, month, year, name } = this.state

        let { handlePage, makeDaysInMonth } = this

        return [
            <h1 key={uuid()}>
                {name} {year}
            </h1>,
            <table key={uuid()}>
                <thead>
                    <tr>
                        {"Man0Tirs0Ons0Tors0Fre0Lør0Søn".split`0`.map(day => (
                            <th key={uuid()}>{day}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>{makeDaysInMonth()}</tbody>
            </table>,
            <Previous
                onClick={() => {
                    handlePage(-1)
                }}
            >
                Forrige
            </Previous>,
            <Next
                onClick={() => {
                    handlePage(1)
                }}
            >
                Neste
            </Next>,
        ]
    }
}

export class FrontPageCalendar extends Component {
    constructor(props) {
        super(props)

        let { month, day, year, name } = new MakeCalendar(0)

        this.state = {
            month: props.month,
            day: props.day,
            year: props.year,
            current: 0,
            name: props.name,
            url: this.props.url,
        }

        this.handlePage = this.handlePage.bind(this)
        this.selectDate = this.selectDate.bind(this)
        this.makeDaysInMonth = this.makeDaysInMonth.bind(this)
    }

    async handlePage(val) {
        let { current } = this.state
        let { month, year, name } = new MakeCalendar(current + val)
        let day = 1
        await this.setState(prevState => {
            let { month, year, name, day } = new MakeCalendar(prevState.current + val)
            return {
                current: prevState.current + val,
                month: month,
                year: year,
                name: name,
                day: prevState.current + val === 0 ? day : 1,
            }
        })
        console.log(month)
        this.props.changeMonth({
            day: day < 10 ? "0" + day : day,
            month,
            year,
            name,
        })
    }

    async selectDate(x, e) {
        let { current } = this.state
        let { month, year, name } = new MakeCalendar(current)
        let day = x

        await this.setState({
            day: day,
            year: year,
            month: month,
            name: name,
            url: `${this.props.url}?day=${day < 10 ? "0" + day : day}&month=${month}&year=${year}`,
        })
        this.props.date({ day: day < 10 ? "0" + day : day, month, year, name })
    }

    makeDaysInMonth() {
        let { current, day } = this.state
        let { selectDate } = this

        let { daysInMonth, weekday, monthS } = new MakeCalendar(current)
        let { nowDay, nowMonth } = new MakeCalendar(0)

        if (typeof day === "string") {
            day = parseInt(day)
        }

        let days = Array.from({ length: daysInMonth }, (v, i) => {
            return (
                <td
                    onClick={selectDate.bind(null, i + 1)}
                    key={uuid()}
                    style={{ border: "2px solid black" }}
                    className={
                        "calendar-day-frontpage" +
                        (i + 1 === day && nowMonth === monthS ? " selected-day-frontpage" : "")
                    }
                >
                    <div
                        style={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                alignSelf: "end",
                                fontWeight: "bold",
                                fontSize: "36px",
                                position: "relative",
                                top: -6,
                                left: -6,
                                color: "rgba(0, 0, 0, 0.6)",
                            }}
                        >
                            {++i}
                        </div>
                        <div
                            style={{
                                justifyContent: "flex-end",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >

                            <div style={{ display: "flex" }}>
                                <span style={{ fontSize: "18px" }}>{this.props.info.res[i].length}</span>
                                <i style={{ color: "#757575" }} class="material-icons">
                                    table_chart
                                </i>
                            </div>
                            <div style={{ display: "flex" }}>
                                <span style={{ fontSize: "18px" }}>{this.props.info.glist[i].length}</span>
                                <i style={{ color: "#757575" }} class="material-icons">
                                    people
                                </i>
                            </div>
                        </div>

                    </div>
                </td>
            )
        })

        let empty = Array.from({ length: parseInt(weekday) }, v => <td />)

        let rows = []
        let container = []
        ;[...empty, ...days].map((day, i) => {
            if (i % 7 === 0 && !i == 0) {
                rows.push(<tr>{container}</tr>)
                container = []
                container.push(day)
            } else {
                container.push(day)
            }
        })
        return [...rows, <tr>{container}</tr>]
    }

    render() {
        console.log(this.state)
        let { day, month, year, name } = this.state

        let { handlePage, makeDaysInMonth } = this

        return [
            <h1 key={uuid()}>
                {name.replace(/\w/, c => c.toUpperCase())} {year}
            </h1>,
            <Previous
                style={button}
                onClick={() => {
                    handlePage(-1)
                }}
            >
                Forrige
            </Previous>,
            <Next
                style={button}
                onClick={() => {
                    handlePage(1)
                }}
            >
                Neste
            </Next>,

            <div style={{ overflowX: "auto" }}>
                <table key={uuid()}>
                    <thead>
                        <tr style={{ backgroundColor: "#0277bd", color: "white" }}>
                            {"Man0Tirs0Ons0Tors0Fre0Lør0Søn".split`0`.map(day => (
                                <th key={uuid()}>{day}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>{makeDaysInMonth()}</tbody>
                </table>
            </div>,
        ]
    }
}

const button = {
    width: "160px",
    marginBottom: "20px",
    marginRight: "10px",
    marginLeft: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
    paddingLeft: "5px",
    paddingRight: "5px",
    fontSize: "18px",
    borderRadius: "8px",
    backgroundColor: "#0277bd",
    color: "white",
}

/*

Different kinds of native html elements in another name space with props passed to them.

*/

const Input = props => <input {...props} />
const Label = props => <label {...props}>{props.children}</label>
const Button = props => <button {...props}>{props.children}</button>
const Tittel = props => <h1 {...props}>{props.children}</h1>

/*

 A general input field for a form.

*/

const GeneralInput = props => [
    <Label key={uuid()} htmlFor={`${props.id}-${props.name}`}>
        {props.children}
    </Label>,
    <Input
        key={uuid()}
        type={props.type}
        id={`${props.id}-${props.name}`}
        name={props.name}
        onChange={props.onChange}
        value={props.value}
    />,
]

GeneralInput.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string.isRequired,
}

const FirstName = props => <GeneralInput type="text" {...props} />
const LastName = props => <GeneralInput type="text" {...props} />
const Email = props => <GeneralInput type="text" {...props} />
const Name = props => <GeneralInput type="text" {...props} />
const Phone = props => <GeneralInput type="text" {...props} />
const Search = props => <GeneralInput type="text" {...props} />
const Count = props => <GeneralInput type="text" {...props} />
const File = props => <GeneralInput type="file" {...props} />
const Submit = props => (
    <Button type="submit" {...props}>
        {props.children}
    </Button>
)
const Open = props => <Button {...props}>{props.children}</Button>
const Next = props => <Button {...props}>{props.children}</Button>
const Previous = props => <Button {...props}>{props.children}</Button>
const Page = props => <Button {...props}>{props.children}</Button>

Open.propTypes = {
    name: PropTypes.string.isRequired,
}

const SearchBar = props => (
    <Form id={props.id} submitMessage="Søk" className="search" query={true} url={props.url} {...props}>
        <Search name="search">
            <svg width="17px" height="18px" viewBox="0 0 17 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path
                        d="M16.8106109,16.1459721 C16.8738495,16.2092105 16.9054687,16.2935285 16.9054687,16.3989256 C16.9054687,16.5043227 16.8738495,16.5991803 16.8106109,16.6834983 L16.4944183,16.968071 C16.4101001,17.052389 16.3152423,17.0945477 16.2098449,17.0945477 C16.1044476,17.0945477 16.0201294,17.052389 15.9568908,16.968071 L11.8780059,12.8891958 C11.7936877,12.8259574 11.7515289,12.7416394 11.7515289,12.6362423 L11.7515289,12.3200504 C11.1613025,12.8681162 10.4814883,13.2949752 9.71208644,13.6006275 C8.94268454,13.9062798 8.13639334,14.0591057 7.29321284,14.0591057 C6.09168085,14.0591057 4.99027669,13.7639935 3.98899987,13.1737685 C2.98772306,12.5835435 2.19197193,11.7877943 1.60174553,10.7865199 C1.01151913,9.78524542 0.716406174,8.68384389 0.716406174,7.48231477 C0.716406174,6.28078565 1.01151913,5.17938411 1.60174553,4.17810968 C2.19197193,3.17683525 2.98772306,2.38108603 3.98899987,1.79086103 C4.99027669,1.20063604 6.09168085,0.905523786 7.29321284,0.905523786 C8.49474482,0.905523786 9.59614898,1.20063604 10.5974258,1.79086103 C11.5987026,2.38108603 12.3944537,3.17683525 12.9846801,4.17810968 C13.5749065,5.17938411 13.8700195,6.28078565 13.8700195,7.48231477 C13.8700195,8.32549326 13.7171932,9.13178254 13.4115402,9.9011826 C13.1058872,10.6705827 12.6790271,11.3503952 12.13096,11.9406202 L12.4471527,11.9406202 C12.5525501,11.9406202 12.6474078,11.9827789 12.731726,12.0670969 L16.8106109,16.1459721 Z M7.29319715,13.0472918 C8.30501115,13.0472918 9.23777718,12.7996083 10.0914952,12.3042408 C10.9452133,11.8088734 11.6197558,11.1343309 12.1151232,10.2806129 C12.6104907,9.42689479 12.8581741,8.49412876 12.8581741,7.48231477 C12.8581741,6.47050077 12.6104907,5.53773474 12.1151232,4.68401668 C11.6197558,3.83029862 10.9452133,3.15575612 10.0914952,2.66038869 C9.23777718,2.16502126 8.30501115,1.91733778 7.29319715,1.91733778 C6.28138316,1.91733778 5.34861713,2.16502126 4.49489907,2.66038869 C3.64118101,3.15575612 2.96663851,3.83029862 2.47127108,4.68401668 C1.97590364,5.53773474 1.72822017,6.47050077 1.72822017,7.48231477 C1.72822017,8.49412876 1.97590364,9.42689479 2.47127108,10.2806129 C2.96663851,11.1343309 3.64118101,11.8088734 4.49489907,12.3042408 C5.34861713,12.7996083 6.28138316,13.0472918 7.29319715,13.0472918 Z"
                        id={`${props.id}-svg`}
                        fill="currentColor"
                    />
                </g>
            </svg>
        </Search>
    </Form>
)

SearchBar.propTypes = {
    id: PropTypes.string.isRequired,
}

const Delete = props => (
    <Form submitMessage="Slett" className="delete" url={props.url} id="delete-toggle">
        <GeneralInput style={{ visibility: "hidden" }} type="text" {...props} />)
    </Form>
)

const Edit = props => (
    <Form className="edit" submitMessage={props.name === "edit" ? "Rediger" : "Lagre"} url={props.url} id="edit-toggle">
        {props.listKeys.map(key => (
            <GeneralInput type="text" {...props} />
        ))}
    </Form>
)

const RegisterNewGuest = props => (
    <Form id="guest" submitMessage="Legg til gjest" url={props.url}>
        <Name name="name">Skriv inn navn</Name>
        <Email name="email">Skriv inn epost</Email>
        <Phone name="telephone">Skriv inn telefon</Phone>
        <Count name="count">Skriv inn antall</Count>
    </Form>
)

RegisterNewGuest.propTypes = {
    url: PropTypes.string.isRequired,
}

const Upload = props => (
    <form>
        <File
            onChange={e => {
                Papa.parse(e.target.files[0], {
                    complete(results) {
                        results.data.reduce((acc, val) => acc.concat(val), [])
                    },
                })
            }}
            id={`${props.id}-file`}
        />
    </form>
)

Upload.propTypes = {
    method: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
}

const Modal = props => {
    let { ui, parent, visible } = props
    let { modal } = styles(ui)
    return (
        <aside parent={parent} className={`modal ${visible ? "active" : "closed"}`} {...props}>
            {props.children}
        </aside>
    )
}

class View extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ui: "light",
            data: [],
        }

        this.uiChange = this.uiChange.bind(this)
    }

    uiChange() {
        this.setState(prevState => ({
            ui: prevState.ui === "light" ? "dark" : "light",
        }))
        if (this.state.ui === "light") {
            // document.body.style.background = '#000507'
        } else {
            // document.body.style.background = '#f3f3f3'
        }
    }

    render() {
        let { uiChange } = this
        let { ui } = this.state
        let { children } = this.props
        return [
            ...Children.map(children, child =>
                cloneElement(child, {
                    ui: ui,
                    parent: this,
                    date: new MakeCalendar(this.props.month),
                }),
            ),
            <Button onClick={uiChange}>{ui === "dark" ? "Bytt til lyst" : "Bytt til mørkt"}</Button>,
        ]
    }
}

const Info = props => {
    if (props.data) {
        return (
            <ul>
                {props.listKeys.map((key, i) => (
                    <li key={i}>{props.data[key]}</li>
                ))}
            </ul>
        )
    } else {
        return []
    }
}

class GuestList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggle: false,
            calendar: false,
            upload: false,
            info: false,
            month: 0,
            day: new Date().getDate(),
            year: new Date().getFullYear(),
            url: this.props.url,
            data: {},
        }
    }

    render() {
        let { toggle, calendar, upload, day, url, info } = this.state

        let { month, year } = new MakeCalendar(this.state.month)
        console.log(url)
        return (
            <View>
                <Tittel>Gjesteliste</Tittel>

                <Modal visible={calendar}>
                    <Actions context={this}>
                        <Open name="calendar">Lukk</Open>
                    </Actions>
                    <Calendar
                        url={this.props.url}
                        current={day}
                        date={new MakeCalendar(month)}
                        context={this}
                        method="get"
                    />
                </Modal>

                <SearchBar context={this} id="main-search" />

                <Modal visible={toggle}>
                    <Actions context={this}>
                        <Open name="toggle">Lukk</Open>
                    </Actions>
                    <RegisterNewGuest />
                    <SearchBar context={this} id="modal-search" />
                    {/* <List
            url={url}
            current={day}
            date={new MakeCalendar(month)}
            listKeys={['name', '_id']}
            context={this}
            method="get"
            data={[]}
            check={() => {
              console.log('hey')
            }}
          >
            Det er ingen resultater fra søket.
          </List> */}
                    <Actions context={this}>
                        <Open name="upload">Last opp</Open>
                    </Actions>
                    <Modal visible={upload}>
                        <Actions context={this}>
                            <Open name="upload">Lukk</Open>
                        </Actions>
                        <Upload />
                    </Modal>
                </Modal>

                <Actions context={this}>
                    <Open name="toggle">Registrer ny person</Open>
                    <Open name="calendar">Kalender</Open>
                </Actions>

                <List
                    url={url}
                    baseUrl={this.props.url}
                    listName="guests"
                    listKeys={["name", "_id", "totalEntered"]}
                    range="totalEntered"
                    max="totalAmount"
                    min={0}
                    context={this}
                    method="get"
                >
                    <Button data-value="1">+</Button>
                    <Button data-value="0">-</Button>
                </List>
            </View>
        )
    }
}

export default class AdminLayout extends Component {
    componentDidMount() {
        this.props.onMount()
    }

    render() {
        return [
            <Navigation />,
            <main id="main" style={{ width: "100%" }}>
                <Switch>
                    {/* <Route path="/admin/groups" component={ConnectGroups} /> */}
                    <Route path="/admin/main" component={FrontPageContainer} />
                    <Route path="/admin/guestlist" component={GuestlistsReal} />
                    {/* <Route component={fouroffour} /> */}
                    <Route path="/admin/employees" component={EmployeesContainer} />
                    <Route path="/admin/tableorder" component={Reservations} />
                    <Route path="/admin/statistics" component={Statistics} />
                    <Route path={"/admin/groups"} component={Groups} />
                    <Route path="/admin/communication" component={Communications} />
                    <Route path="/admin/benefits" component={BenefitsContainer} />
                    <Route path="/admin/guests" component={Guests} />
                    <Route path="/admin/products" component={ProductsContainer} />
                    <Route path="/admin/settings" component={Settings} />
                </Switch>
            </main>,
        ]
    }
}
